import { AwaitRouterData } from '@src/routing/AwaitRouterData';
import { Loaders } from '@src/routing/Loaders';
import { Navigation } from '@src/routing/Navigation';
import { Refreshable } from '@src/routing/Refreshable';
import { AddTractorPage } from '@src/tractor/AddTractorPage';
import { EditTractorPage } from '@src/tractor/EditTractorPage';
import { AddTrailerPage } from '@src/trailer/AddTrailerPage';
import { EditTrailerPage } from '@src/trailer/EditTrailerPage';
import type { RouteObject } from 'react-router-dom';

export const clientTractorsAndTrailersRoutes: RouteObject[] = [
  {
    path: Navigation.clients.tractors.add.RELATIVE,
    loader: Loaders.client.loader,
    element: (
      <AwaitRouterData path={Loaders.client.path}>
        {(data) => <AddTractorPage client={data} />}
      </AwaitRouterData>
    ),
  },
  {
    path: Navigation.clients.tractors.edit.RELATIVE,
    loader: Loaders.tractor.loader,
    element: (
      <AwaitRouterData path={Loaders.tractor.path}>
        {([client, tractor]) => (
          <EditTractorPage client={client} tractor={tractor} />
        )}
      </AwaitRouterData>
    ),
  },
  {
    path: Navigation.clients.trailers.add.RELATIVE,
    loader: Loaders.client.loader,
    element: (
      <AwaitRouterData path={Loaders.client.path}>
        {(data) => (
          <Refreshable children={() => <AddTrailerPage client={data} />} />
        )}
      </AwaitRouterData>
    ),
  },
  {
    path: Navigation.clients.trailers.edit.RELATIVE,
    loader: Loaders.trailer.loader,
    element: (
      <AwaitRouterData path={Loaders.trailer.path}>
        {([client, trailer]) => (
          <Refreshable
            children={() => (
              <EditTrailerPage client={client} trailer={trailer} />
            )}
          />
        )}
      </AwaitRouterData>
    ),
  },
];
